<template>
  <v-card flat tile>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" sm="4">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formData.date"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                :disabled="savingForm == true"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="formData.date"
              @input="dateMenu = false"
            ></v-date-picker>
            <!-- <v-date-picker
              v-model="formData.date"
              @input="dateMenu = false"
              :min="currentWeek[0]"
              :max="currentDate"
            ></v-date-picker> -->
          </v-menu>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="5">
          <v-text-field
            v-model="hours"
            label="Hours"
            prepend-icon="mdi-timer-sand"
            @keypress="isInt($event)"
            :disabled="savingForm == true"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="minutes"
            label="Minutes"
            @keypress="isInt($event)"
            :disabled="savingForm == true"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-btn
            class="mb-2"
            icon
            color="green lighten-1"
            small
            @click="updateDuration(10)"
            ><v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn
            class="mb-2"
            icon
            color="red lighten-1"
            small
            @click="updateDuration(-10)"
            :disabled="formData.duration == null || formData.duration == 0"
            ><v-icon>
              mdi-minus
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="4">
          <v-file-input
            label="Attach File"
            v-model="fileData"
            :disabled="savingForm == true || formData.s3FilePath != null"
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-textarea
          filled
          label="Notes"
          auto-grow
          v-model="formData.description"
          :disabled="savingForm == true"
        ></v-textarea>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'SubmitTimeForm',
  props: ['userid', 'data', 'savingForm', 'action', 'lastsubmission'],
  data: () => ({
    dateMenu: false,
    presignedUrl: null,
    fileData: null,
    s3FilePath: null,
    s3FileContentType: null,
    hours: 0,
    minutes: 0,
    formData: {
      date: null,
      duration: 0,
      description: null,
      userId: null,
    },
  }),
  computed: {
    userStoreData() {
      return this.$store.getters.getUsers
    },
    projectStoreData() {
      return this.$store.getters.getProjects
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser
    },
    submitUserId() {
      return this.userid != null ? this.userid : this.loggedInUser.id
    },
    currentWeek() {
      return this.$store.getters.getCurrentWeek
    },
    currentDate() {
      return new moment().format('YYYY-MM-DD')
    },
    validForm() {
      return (
        this.formData.date !== null &&
        this.formData.date !== '' &&
        this.formData.description !== null &&
        this.formData.description !== '' &&
        this.formData.description !== undefined &&
        (this.minutes > 0 || this.hours > 0) &&
        (this.action != 'Edit' ||
          this.formData.date != this.data.date ||
          this.formData.duration != this.data.duration ||
          this.formData.description != this.data.description ||
          this.fileData != null)
      )
    },
  },
  watch: {
    hours() {
      this.formData.duration =
        parseFloat(this.hours) + parseFloat(this.minutes) / 60.0
    },
    minutes(val) {
      if (val > 59) {
        this.hours = parseInt(this.hours) + parseInt(this.minutes / 60)
        this.minutes = parseInt(this.minutes % 60)
      }
      this.formData.duration =
        parseFloat(this.hours) + parseFloat(this.minutes) / 60.0
    },
    savingForm(newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.$emit(
          'loading',
          this.action == 'Delete'
            ? 'Deleting Time Submission'
            : this.action + 'ing Time Submission'
        )
        this.getPresignedUrl()
      }
    },
    validForm(val) {
      if (val == true) {
        this.$emit('valid-form', true)
      } else {
        this.$emit('valid-form', false)
      }
    },
  },
  methods: {
    isInt: function(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    submitTime() {
      if (this.action == 'Add') {
        this.addTimeSubmission()
      } else if (this.action == 'Edit') {
        this.editTimeSubmission()
      } else if (this.action == 'Delete') {
        this.deleteTimeSubmission()
      }
    },
    prepareFormDataForSubmit() {
      if (this.action == 'Add') {
        this.formData.payRate = this.userStoreData[this.userid].payRate
      }
      for (var serviceType of this.projectStoreData[this.formData.projectId]
        .serviceTypes) {
        if (serviceType.id == this.formData.serviceType) {
          this.formData.rate = serviceType.laborRate
        }
      }
      if (this.s3FilePath != null) {
        this.formData.s3FilePath = this.s3FilePath
        this.formData.s3FileContentType = this.s3FileContentType
      }
    },
    getChangedSubmissionData() {
      let changedData = {}
      let oldData = this.data
      for (var key in this.formData) {
        if (oldData[key] != this.formData[key]) {
          changedData[key] = this.formData[key]
        }
      }
      // eslint-disable-next-line
      console.log(changedData)
      if (changedData.duration != null) {
        changedData.changedHours =
          parseFloat(changedData.duration) - parseFloat(oldData.duration)
        changedData.changedBillableLabor =
          parseFloat(changedData.changedHours) * parseFloat(oldData.rate)
      } else {
        changedData.duration = parseFloat(oldData.duration)
        changedData.changedHours = 0
        changedData.changedBillableLabor = 0
      }

      return changedData
    },
    editTimeSubmission() {
      this.prepareFormDataForSubmit()
      this.$store
        .dispatch('editTimeSubmission', {
          id: this.formData.id,
          changedData: this.getChangedSubmissionData(),
          taskId: this.formData.taskId,
          projectId: this.formData.projectId,
        })
        .then(result => {
          if (result.success != true) {
            this.$emit('error', result.data.error.message)
          } else {
            this.$emit('success', 'Successfully edited time submission!')
            this.$emit('update-table')
          }
        })
    },
    deleteTimeSubmission() {
      this.$store
        .dispatch('deleteTimeSubmission', {
          id: this.formData.id,
          changedData: {
            changedBillableLabor: -this.data.rate * this.data.duration,
            changedHours: -this.data.duration,
          },
          taskId: this.formData.taskId,
          projectId: this.formData.projectId,
        })
        .then(result => {
          if (result.success != true) {
            this.$emit('error', result.data.error.message)
          } else {
            this.$emit('success', 'Successfully deleted time submission!')
            this.$emit('update-table')
          }
        })
    },
    addTimeSubmission() {
      this.prepareFormDataForSubmit()
      this.$store.dispatch('submitTime', this.formData).then(result => {
        if (result.success != true) {
          this.$emit('error', result.data.error.message)
        } else {
          this.$emit('success', 'Successfully added time submission!')
          this.$emit('update-table', {
            action: 'add',
            item: result.data.timesubmission,
          })
        }
      })
    },
    getPresignedUrl() {
      if (this.fileData != null) {
        this.s3FilePath =
          this.loggedInUser.companyId +
          '/' +
          this.formData.projectId +
          '/' +
          this.formData.taskId +
          '/time/' +
          moment().format('YYYY-MM-DD h-mm-ss a') +
          this.fileData.name
        this.s3FileContentType = this.fileData.type
        let payload = {
          action: 'putObject',
          path: this.s3FilePath,
          contentType: this.fileData.type,
        }
        this.$store.dispatch('getPresignedUrl', payload).then(result => {
          if (result.success == false) {
            this.$emit('error', result.data.error.message)
          } else {
            this.presignedUrl = result.data
            this.uploadFileToS3()
          }
        })
      } else {
        this.submitTime()
      }
    },
    uploadFileToS3() {
      let contentType = this.fileData.type
      var reader = new FileReader()
      reader.readAsDataURL(this.fileData)
      reader.addEventListener('load', () => {
        let payload = {
          presignedUrl: this.presignedUrl,
          contentType: contentType,
          fileBody: reader.result,
        }

        this.$store.dispatch('uploadFileToS3', payload).then(result => {
          if (result.success == false) {
            this.$emit('error', result.data.error.message)
          } else {
            this.submitTime()
          }
        })
      })
    },
    updateDuration(increment) {
      if (this.minutes == null) {
        this.minutes = increment
      } else {
        if (this.minutes % increment != 0) {
          if (increment > 0) {
            increment = 10 - (this.minutes % increment)
          } else {
            increment = -(this.minutes % increment)
          }
        }

        let newMinutes = parseInt(this.minutes) + parseInt(increment)
        this.minutes = newMinutes
      }
    },
  },
  mounted() {
    this.formData = JSON.parse(JSON.stringify(this.data))
    this.formData.userId = this.userid
    this.formData.date = this.currentDate
    if (this.action == 'Add') {
      this.formData.duration = 0
    }
    if (this.action == 'Edit') {
      this.hours = parseInt(this.data.duration)
      this.minutes = parseInt(
        ((this.data.duration - this.hours) * 60).toFixed(2)
      )
    }
  },
}
</script>

<style>
.forceuppercase input {
  text-transform: uppercase;
}
</style>
